function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2731 9.43403C10.2731 9.72594 10.0414 9.9626 9.75555 9.9626H7.84459C7.55874 9.9626 7.32699 9.72594 7.32699 9.43403C7.32699 9.14211 7.55874 8.90545 7.84459 8.90545H9.75555C10.0414 8.90545 10.2731 9.14211 10.2731 9.43403ZM16.6 1.52858V4.81138C16.6 5.1033 16.3683 5.33996 16.0824 5.33996H15.7469V12.4714C15.7469 12.7633 15.5152 13 15.2293 13H2.37073C2.08488 13 1.85314 12.7633 1.85314 12.4714V5.34H1.5176C1.23174 5.34 1 5.10334 1 4.81143V1.52858C1 1.23666 1.23174 1 1.5176 1H16.0824C16.3683 1 16.6 1.23666 16.6 1.52858ZM14.7117 5.34H11.4103C11.1687 6.58615 10.0902 7.52855 8.80007 7.52855C7.50999 7.52855 6.43137 6.58615 6.18988 5.34H2.88833V11.9428H14.7117V5.34ZM8.80007 6.4714C9.51553 6.4714 10.1245 5.99698 10.3411 5.34H7.259C7.47564 5.99698 8.08461 6.4714 8.80007 6.4714ZM15.5648 2.05715H2.03519V4.2828H15.5648V2.05715Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

function SvgArchiveBoxicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBoxicon);
export default __webpack_public_path__ + "static/media/archive-box.icon.3007a016.svg";
export { ForwardRef as ReactComponent };